
import { PropsWithChildren } from "react";

export default function AuthLayout({ children }: PropsWithChildren) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-8 p-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold">Turnles Planner</h2>
          <p className="text-muted-foreground mt-2">Maak eenvoudig je lesplannen</p>
        </div>
        {children}
      </div>
    </div>
  );
}
